export default __webpack_public_path__ + "static/media/instruments.bd1ff622.png";